import axios from "axios";
import { logger } from "@/helpers/tslog";
import { getToken } from "@/utils/localstorage";

function getApiUrl(): string | undefined {
  return process.env.API_URL?.replace(/\/+$/, "");
}

export function getPresentationDialogReturnBase(): string {
  const fromEnv = process.env.REACT_APP_PUBLIC_URL?.replace(/\/+$/, "");
  if (fromEnv) return fromEnv;
  try {
    return `${window.location.protocol}//${window.location.host}`;
  } catch {
    return "";
  }
}

export function getPresentationDialogReturnUrl(): string {
  try {
    return `${window.location.origin}${window.location.pathname}`;
  } catch {
    const base = getPresentationDialogReturnBase();
    return base ? `${base}/presentation.html` : "";
  }
}

export async function getCurrentUserEmail(): Promise<string | null> {
  const apiUrl = getApiUrl();
  if (!apiUrl) return null;
  try {
    const token = await getToken();
    const { data } = await axios.get<{ email?: string; userEmail?: string }>(`${apiUrl}/user/current-user`, {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      withCredentials: true,
    });
    const email = data?.email ?? data?.userEmail ?? null;
    if (!email?.trim()) {
      logger.warn("[getCurrentUserEmail] current-user response had no email");
      return null;
    }
    return email.trim();
  } catch (e) {
    logger.warn("[getCurrentUserEmail] failed to load current user", e);
    return null;
  }
}

export async function isOneDriveAuthenticated(userEmail: string): Promise<boolean> {
  const apiUrl = getApiUrl();
  if (!apiUrl || !userEmail) return false;
  try {
    const token = await getToken();
    const response = await axios.get<{ authenticated?: boolean }>(`${apiUrl}/onedrive/auth/status`, {
      params: { userEmail },
      headers: token ? { Authorization: `Bearer ${token}` } : {},
      withCredentials: true,
    });
    return response.data?.authenticated === true;
  } catch {
    return false;
  }
}

export function startOneDriveAuthRedirect(userEmail: string, returnUrl: string): void {
  const apiUrl = getApiUrl();
  if (!apiUrl) {
    throw new Error("API_URL is not configured");
  }
  const authUrl = `${apiUrl}/onedrive/auth/initiate?returnUrl=${encodeURIComponent(returnUrl)}&userEmail=${encodeURIComponent(userEmail)}`;
  window.location.href = authUrl;
}
